import React, { PureComponent } from 'react';
import { themr } from 'react-css-themr';
import defaultTheme from './SubMenuContent.scss';

import { ListItemComponent } from './MenuList';

export const defaultSelectComponentFactory = ({
    ListItem = ListItemComponent
}) => {
    return class SelectComponent extends React.PureComponent {
        render() {
            const {
                source,
                selectedItem,
                hoveredItem,
                activeItem,
                onItemClick,
                onItemMouseEnter,
                onItemMouseLeave,
                ...others
            } = this.props;
            return (
                <React.Fragment>
                    {source.map(item => {
                        const isSelected =
                            selectedItem && selectedItem.value === item.value;
                        const isHovered =
                            (hoveredItem && hoveredItem.value === item.value) ||
                            (activeItem && activeItem.value === item.value);
                        const isDisabled = item.disabled;
                        return (
                            <ListItem
                                {...others}
                                item={item}
                                key={item.value}
                                onItemClick={onItemClick}
                                onItemMouseEnter={onItemMouseEnter}
                                onItemMouseLeave={onItemMouseLeave}
                                isSelected={isSelected}
                                isHovered={isHovered}
                                isDisabled={isDisabled}
                            />
                        );
                    })}
                </React.Fragment>
            );
        }
    };
};

const SubMenuContentFactory = ({
    List,
    SelectComponentFactory = defaultSelectComponentFactory
}) => {
    const SelectComponent = SelectComponentFactory({ List });
    class SubMenuContent extends PureComponent {
        render() {
            const { className, theme, ...other } = this.props;
            return (
                <div className={theme.subMenuContentWrapper}>
                    <SelectComponent
                        {...other}
                        theme={theme}
                        className={className}
                    />
                </div>
            );
        }
    }

    return themr('SubMenuContent', defaultTheme)(SubMenuContent);
};

const SubMenuContent = SubMenuContentFactory({});
export { SubMenuContent, SubMenuContentFactory };
